<template>
	<AsiListTableLayout :has-filter="hasFilter" hide-toolbar>
		<AsiContentContainer no-bottom-margin no-top-margin>
			<v-data-table
				:footer-props="{itemsPerPageOptions: perPageOptions}"
				:headers="createHeaders()"
				:items="items"
				:loading="loadingInternal"
				:options.sync="tableOptions"
				:server-items-length="total"
				item-key="id"
				multi-sort>

				<template v-slot:item.item.avatar="{item}">
					<v-img class="ma-1" :src="avatarUrl(item.item)" :aspect-ratio="1" width="40"/>
				</template>

				<template v-slot:item.customerItemNumber="{item}">
					<AsiLabel :text="item.customerItemNumber" italic/>
				</template>

				<template v-slot:item.item.itemNumber="{item}">
					<AsiLabel :text="item.item.itemNumber" italic/>
				</template>

				<template v-slot:item.customer.name="{item}">
					<AsiLabel :text="item.customer.name" italic/>
				</template>
			</v-data-table>
		</AsiContentContainer>
	</AsiListTableLayout>
</template>

<script lang="ts">
	import {Component, Prop, Watch} from 'vue-property-decorator';
	import AsiListTable from "@/components/common/AsiListTable.vue";
	import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
	import {IItemAdmin, IItemAdminListEntry} from "@/models/item/ItemAdminModels";
	import {ICustomerItemAdminListEntry} from "@/models/customer-item/CustomerItemAdminModels";
	import CustomerItemListFilterAdmin from "@/models/customer-item/CustomerItemListFilterAdmin";
	import AsiListTableLayout from "@/components/common/AsiListTableLayout.vue";
	import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
	import AsiListTableHeader from "@/components/common/AsiListTableHeader";
	import IPaginatedResponse from "@/models/IPaginatedResponse";
	import AsiListTableOptions from "@/components/common/AsiListTableOptions";
	import AsiLabel from "@/components/common/AsiLabel.vue";
	import ItemHelper from "@/models/item/ItemHelper";
	import {AttachmentMediaSize} from "@/helpers/constants";
	import AsiAvatar from "@/components/common/AsiAvatar.vue";
	import icons from "@/plugins/icons";
	import {color} from "chart.js/helpers";

	@Component({
		methods: {color},
		computed: {
			icons() {
				return icons;
			}
		},
		components: {AsiAvatar, AsiLabel, AsiContentContainer, AsiListTableLayout}
	})
	export default class CustomerItemList extends AsiListTable<ICustomerItemAdminListEntry, CustomerItemListFilterAdmin> implements IAsiListTableImplementation<ICustomerItemAdminListEntry, CustomerItemListFilterAdmin> {

		@Prop({required: true})
		public itemModel!: IItemAdmin;

		@Prop({type: Boolean, default: false})
		public hideToolbar!: boolean;

		@Prop({
			type: Object, default: () => {
				return new CustomerItemListFilterAdmin();
			}
		})
		public filter!: CustomerItemListFilterAdmin;

		private initialized: boolean = false;

		public created(): void {
			this.reload(false, false);
			this.$nextTick(() => this.initialized = true);
		}

		public createFilterModel(): CustomerItemListFilterAdmin {
			return this.filter;
		}

		public createHeaders(): AsiListTableHeader[] {
			return [
				new AsiListTableHeader('', 'item.avatar', false, false, 'center', '5rem'),
				new AsiListTableHeader(this.$t('customerItem.number'), 'customerItemNumber', false, false, 'center', '5rem'),
				new AsiListTableHeader(this.$t('item.itemNumber'), 'item.itemNumber', false, false, 'center', '5rem'),
				new AsiListTableHeader(this.$t('customer.name'), 'customer.name', false, false, 'center', '5rem'),
			];
		}

		public fetchData(filterModel: CustomerItemListFilterAdmin | null, tableOptions: AsiListTableOptions | null): Promise<IPaginatedResponse<ICustomerItemAdminListEntry>> {
			if (filterModel === null) {
				filterModel = new CustomerItemListFilterAdmin();
			}
			filterModel.itemNumber = this.itemModel.itemNumber;
			return this.$customerItemServiceAdmin.customerItems(filterModel, tableOptions);
		}

		public filterTextChanged(filterText: string): void {
			if (this.filter === null) return;
			this.filter.fulltext = filterText;
		}

		public reload(goToFirstPage: boolean = false, debounce: boolean = true): void {
			this.reloadInternal(this, goToFirstPage, debounce);
		}

		/* eslint-disable @typescript-eslint/no-unused-vars */
		openModelDetailPage(model: ICustomerItemAdminListEntry): void {
			// do nothing
		}

		protected prepareOptions(options: AsiListTableOptions): AsiListTableOptions {
			if (options.sortBy.length === 0 && this.defaultSortBy.length === 0) {
				options.sortBy = ['name'];
				options.sortDesc = [false];
			}
			return options;
		}

		@Watch('tableOptions', {deep: true})
		private onTableOptionsChanged(): void {
			if (!this.initialized) return;
			this.reload();
		}

		// noinspection JSMethodCanBeStatic
		private avatarUrl(item: IItemAdminListEntry): string | null {
			return ItemHelper.avatarUrl(item, AttachmentMediaSize.s);
		}
	}

</script>

<style scoped lang="scss">

</style>
